export const pageTitle = title => {
  return (document.title =
    title + ' -  Best IVF & Fertility Clinic in Jabalpur');
};
